import React, { useState, useEffect } from 'react';
import ButtonV2 from 'components/ButtonV2';
import { Input } from 'components/FormFields';
import Toaster from 'components/Toaster';
import { useGetAdminSettings, useUpdateSettings } from '../gql';
import {
  PageHeader,
  PageTitle,
  PageDescription,
  SettingsCard,
  SettingsRow,
} from '../StyledComponents';

const SettingsPage = () => {
  const { settings, loading } = useGetAdminSettings();
  const updateSettings = useUpdateSettings();
  const [formData, setFormData] = useState({
    helpBaseUrl: '',
    showNewBadgeDays: 14,
    maxFeaturedVideos: 6,
  });
  const [saving, setSaving] = useState(false);
  const [toaster, setToaster] = useState({ isOpen: false });

  useEffect(() => {
    if (settings) {
      setFormData({
        helpBaseUrl: settings.help_base_url || '',
        showNewBadgeDays: settings.show_new_badge_days || 14,
        maxFeaturedVideos: settings.max_featured_videos || 6,
      });
    }
  }, [settings]);

  const handleSave = async () => {
    setSaving(true);
    const result = await updateSettings({
      help_base_url: formData.helpBaseUrl,
      show_new_badge_days: formData.showNewBadgeDays,
      max_featured_videos: formData.maxFeaturedVideos,
    });
    setSaving(false);
    setToaster(
      result
        ? {
            isOpen: true,
            type: 'success',
            title: 'Settings Saved',
            message: 'Your Learning Hub settings have been updated.',
          }
        : {
            isOpen: true,
            type: 'error',
            title: 'Error',
            message: 'Failed to save settings. Please try again.',
          }
    );
  };

  if (loading) {
    return (
      <div style={{ padding: '40px', textAlign: 'center' }}>Loading...</div>
    );
  }

  return (
    <>
      <PageHeader>
        <div>
          <PageTitle>Settings</PageTitle>
          <PageDescription>Configure Learning Hub settings</PageDescription>
        </div>
      </PageHeader>

      <SettingsCard>
        <SettingsRow>
          <Input
            label="Default Help Documentation URL"
            value={formData.helpBaseUrl}
            onChange={(e) =>
              setFormData({ ...formData, helpBaseUrl: e.target.value })
            }
            placeholder="https://example.com/help"
            helperText='Base URL for "Learn More" links'
            maxWidth="600px"
          />
        </SettingsRow>

        <SettingsRow>
          <Input
            label="NEW Badge Duration"
            type="number"
            value={formData.showNewBadgeDays}
            onChange={(e) =>
              setFormData({
                ...formData,
                showNewBadgeDays: parseInt(e.target.value) || 0,
              })
            }
            helperText="Days to show NEW badge after publishing"
            width="140px"
          />
        </SettingsRow>

        <SettingsRow>
          <Input
            label="Maximum Featured Videos"
            type="number"
            value={formData.maxFeaturedVideos}
            onChange={(e) =>
              setFormData({
                ...formData,
                maxFeaturedVideos: parseInt(e.target.value) || 0,
              })
            }
            helperText="Limit featured videos in Discover mode"
            width="140px"
          />
        </SettingsRow>
      </SettingsCard>

      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          padding: '16px 0 32px',
        }}
      >
        <div style={{ width: '200px' }}>
          <ButtonV2 primary onClick={handleSave} disabled={saving}>
            {saving ? 'Saving...' : 'Save Settings'}
          </ButtonV2>
        </div>
      </div>

      <Toaster
        isOpen={toaster.isOpen}
        onClose={() => setToaster({ isOpen: false })}
        type={toaster.type}
        title={toaster.title}
        message={toaster.message}
      />
    </>
  );
};

export default SettingsPage;
